import { Tooltip } from 'antd';
import { useMemo, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import SelectSignsModal from '../selectSignsModal';
import {
  AddSignButton,
  EmptyHint,
  RemoveButton,
  SelectedCode,
  SelectedGrid,
  SelectedSign,
} from './styles';
import {
  formatSignNames,
  getIso7010SignImagePath,
  Iso7010SignCode,
  iso7010SignDescriptions,
  parseSignNames,
} from '../../constants/signs';

export interface SignsFieldProps {
  value?: string;
  onChange?: (signNames: string) => void;
  readOnly?: boolean;
}

const SignsField = ({ value, onChange, readOnly }: SignsFieldProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  const selectedCodes = useMemo(() => parseSignNames(value), [value]);

  const handleRemove = (code: Iso7010SignCode) => {
    onChange?.(formatSignNames(selectedCodes.filter((item) => item !== code)));
  };

  return (
    <>
      <SelectedGrid>
        {selectedCodes.map((code) => (
          <SelectedSign key={code}>
            {!readOnly && (
              <RemoveButton
                type="button"
                aria-label={`Remove ${code}`}
                onClick={() => handleRemove(code)}
              >
                ×
              </RemoveButton>
            )}
            <Tooltip title={`${code} - ${iso7010SignDescriptions[code]}`}>
              <img src={getIso7010SignImagePath(code)} alt={code} />
            </Tooltip>
            <SelectedCode>{code.toLowerCase()}</SelectedCode>
          </SelectedSign>
        ))}
        {!readOnly && (
          <SelectedSign
            as="button"
            type="button"
            onClick={() => setModalOpen(true)}
          >
            <AddSignButton>
              <PlusOutlined />
            </AddSignButton>
          </SelectedSign>
        )}
      </SelectedGrid>
      {readOnly && selectedCodes.length === 0 && (
        <EmptyHint>No signs selected</EmptyHint>
      )}
      <SelectSignsModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={(signs) => onChange?.(formatSignNames(signs))}
        selectedSigns={selectedCodes}
        readOnly={readOnly}
      />
    </>
  );
};

export default SignsField;
